import React from 'react';
import '../../../../styles/knowledge-concept/ai-content/ChatGPTLoader.css';

const ChatGPTLoader = () => {
  return (
    <div className="chat-gpt-loader">
      <div className="dot-flashing"></div>
    </div>
  );
};

export default ChatGPTLoader; 